/* eslint-disable unicorn/filename-case */

type AnimatedSettingsIconProps = {
  width?: number;
  height?: number;
  groupName?: string;
  bgColor?: string;
};

export function AnimatedSettingsIcon(props: AnimatedSettingsIconProps) {
  const { width = 24, height = 24, groupName = 'group', bgColor = 'white' } = props;
  // Escape forward slashes for CSS selector (e.g., group/settings-icon -> group\/settings-icon)
  const escapedGroupName = groupName.replace(/\//g, '\\/');

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 24 24"
      className="animated-settings-icon"
    >
      <style>
        {`
          .animated-settings-icon .top-circle,
          .animated-settings-icon .top-line,
          .animated-settings-icon .bottom-circle,
          .animated-settings-icon .bottom-line {
            transition: transform 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
          }
          .${escapedGroupName}:hover .animated-settings-icon .top-circle {
            transform: translateX(-12px);
          }
          .${escapedGroupName}:hover .animated-settings-icon .top-line {
            transform: translateX(6px);
          }
          .${escapedGroupName}:hover .animated-settings-icon .bottom-circle {
            transform: translateX(12px);
          }
          .${escapedGroupName}:hover .animated-settings-icon .bottom-line {
            transform: translateX(-6px);
          }
        `}
      </style>
      {/* Top row: line moves right, circle moves left */}
      <path
        className="top-line"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M3 8h12"
      />
      <circle
        className="top-circle"
        cx="18"
        cy="8"
        r="3"
        stroke="currentColor"
        strokeWidth={2}
        fill={bgColor}
      />
      {/* Bottom row: circle moves right, line moves left */}
      <path
        className="bottom-line"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M9 16h12"
      />
      <circle
        className="bottom-circle"
        cx="6"
        cy="16"
        r="3"
        stroke="currentColor"
        strokeWidth={2}
        fill={bgColor}
      />
    </svg>
  );
}
